import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useSpring, animated as a } from 'react-spring';
import cardStyles from './podcastcard.module.css';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function PodcastCard({ podcast, onPlay }) {
  const navigate = useNavigate();
  const { user, toggleSubscription } = useAuth();
  const [hovered, setHovered] = React.useState(false);

  const springProps = useSpring({
    transform: hovered ? 'translateY(-8px)' : 'translateY(0px)',
    boxShadow: hovered
      ? '0 12px 24px rgba(0, 0, 0, 0.15)'
      : '0 4px 8px rgba(0, 0, 0, 0.1)',
    config: { tension: 300, friction: 20 }
  });

  const isSubscribed = user?.subscriptions?.includes(podcast.id);

  const handleSubscribe = (e) => {
    e.stopPropagation();
    toggleSubscription(podcast.id);
  };

  const handlePlay = (e) => {
    e.stopPropagation();
    onPlay(podcast);
  };

  const handleCardClick = () => {
    navigate(`/podcast/${podcast.id}`);
  };

  return (
    <a.div
      style={springProps}
      className={cardStyles.card}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleCardClick}
    >
      <div className={cardStyles.imageContainer}>
        <img src={podcast.image} alt={podcast.title} className={cardStyles.image} />
        <div className={cardStyles.overlay}>
          <button className={cardStyles.playBtn} onClick={handlePlay}>
            <PlayArrowIcon sx={{ fontSize: 36 }} />
          </button>
        </div>
      </div>

      <div className={cardStyles.content}>
        <h3 className={cardStyles.title}>{podcast.title}</h3>
        <p className={cardStyles.publisher}>{podcast.publisher}</p>
        <div className={cardStyles.meta}>
          <span className={cardStyles.category}>{podcast.category}</span>
          <span className={cardStyles.episodes}>{podcast.totalEpisodes} episodes</span>
        </div>
        <div className={cardStyles.footer}>
          <div className={cardStyles.rating}>
            ⭐ {podcast.rating}
          </div>
          <button
            className={`${cardStyles.subscribeBtn} ${isSubscribed ? cardStyles.subscribed : ''}`}
            onClick={handleSubscribe}
          >
            {isSubscribed ? (
              <>
                <CheckCircleIcon fontSize="small" /> Subscribed
              </>
            ) : (
              <>
                <SubscriptionsIcon fontSize="small" /> Subscribe
              </>
            )}
          </button>
        </div>
      </div>
    </a.div>
  );
}

export default PodcastCard;
